import { AtlasMenuContentItem } from "@resource/atlas";
import FakeMultiSelect from "components/FakeMultiSelect";
import { useMemo } from "react";

import { PaginatedTableFieldFilterOption } from "./types";

export default function MultiSelectFilter({
  fieldId,
  label,
  value,
  options,
  setFilter,
}: {
  fieldId: string;
  label: string;
  value: string[];
  options?: PaginatedTableFieldFilterOption[];
  setFilter: (id: string, val: string[] | null) => void;
}) {
  return (
    <FakeMultiSelect
      label={label}
      minWidth="14rem"
      items={useMemo(
        () =>
          options?.map(
            ({ caption, id }): AtlasMenuContentItem => ({
              _type: "item",
              children: caption,
              key: id,
              value: id,
            })
          ) ?? [],
        [options]
      )}
      selectedIds={value ?? []}
      onSelectedIdsChange={(val) =>
        setFilter(fieldId, val.length === 0 ? null : val)
      }
    />
  );
}
